<template>
  <nav-group>

    <div v-for="link in links" :key="link.name">
      <div v-if="(link.isDev && $isDev) || link.isDev === undefined" :class="link.isDev ? 'isDev' : ''">
        <h5 v-if="link.isTitle" class="nav-group-title">
          <span>{{link.title}}</span>
          </h5>
        <hr v-else-if="link.isHR"/>
        <router-link v-else tag="a" :to="link.to">
          <nav-item :class="selectionClass(link.class ? link.class : link.name)">{{link.name}}</nav-item>
        </router-link>
      </div>
    </div>

  </nav-group>
  
</template>

<script>
export default {
  data: function () {
    return {
      count: 0,
      navSelection : '',
      links: [
        
        
        
        
        {isHR: true},
        {title:"Shifts", isTitle:true},
        {name:"Shifts Page", to:"/Reports/ShiftsPage"},
        {name:"Charges Page", to:"/Reports/Charges"},
        
        
        
        
      ]
    }
  },
  created: function(){
    this.navSelection = this.$route.name
  },
  watch: {
    '$route.name' : function(){
      this.navSelection = this.$route.name
    }
  }, 
  methods: {
    selectionClass: function(name){
      let _name = name.replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '')
      _name = _name.replace(/ /g, '')
      return this.navSelection === _name ? 'active' : '';
    }
  }
}
</script>

<style scoped>
hr {
  margin:0;
}
a {
  text-decoration: none !important;
}

.isDev{
  background-color: rgba(158, 184, 216, 0.297);
}
</style>

